var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMyBusinessRoundLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 2000,
    viewBox: "0 0 32 32",
    width: 2000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 7.72949,
    x2: 23.7514,
    y1: 17.9581,
    y2: 17.9581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#4079d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4989f5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32 16c0-8.83656-7.1634-16-16-16-8.83656 0-16 7.16344-16 16 0 8.8366 7.16344 16 16 16 8.8366 0 16-7.1634 16-16z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m23.1251 12.0066h-14.76901c-.35091 0-.63539.2845-.63539.6354v10.7227c0 .3509.28448.6354.63539.6354h14.76901c.3509 0 .6354-.2845.6354-.6354v-10.7227c0-.3509-.2845-.6354-.6354-.6354z",
    fill: "#4989f5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22.9396 11.9164h-14.41604c-.44657 0-.79407 3.456-.79407 3.9026l7.89461 8.181h7.3155c.4479-.0012.8107-.3641.8119-.812v-10.4598c-.0013-.4479-.3641-.8106-.8119-.8118z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m11.3828 14.0151h4.5828v-6.01486h-3.8966z",
    fill: "#3c4ba6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m20.5486 14.0151h-4.5828v-6.01486h3.8966zm3.2118-4.87467.0057.0205c-.0014-.00723-.0042-.01395-.0057-.0205z",
    fill: "#7babf7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m23.7664 9.16069-.0056-.0205c-.1453-.66532-.7342-1.13976-1.4152-1.14019h-2.4828l.6857 6.015h4.5828z",
    fill: "#3f51b5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m8.1717 9.14038-.00568.0205c.00137-.00723.00413-.01395.00568-.0205z",
    fill: "#7babf7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m8.16551 9.16069.00569-.0205c.14529-.66532.73416-1.13976 1.41515-1.14019h2.48295l-.6867 6.015h-4.5828z",
    fill: "#7babf7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.3826 14.0126c0 1.2634-1.0259 2.2877-2.2914 2.2877-1.26549 0-2.2914-1.0243-2.2914-2.2877z",
    fill: "#709be0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.9656 14.0126c0 1.2634-1.0259 2.2877-2.2914 2.2877s-2.2914-1.0243-2.2914-2.2877z",
    fill: "#3c4ba6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.5481 14.0126c0 1.2634-1.0259 2.2877-2.2914 2.2877s-2.2914-1.0243-2.2914-2.2877z",
    fill: "#709be0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.1311 14.0126c0 1.2634-1.0259 2.2877-2.2914 2.2877s-2.2914-1.0243-2.2914-2.2877z",
    fill: "#3c4ba6"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m22.8409 20.218c-.0081-.109-.0216-.2086-.0407-.3358h-2.4981c0 .3494 0 .7307-.0014 1.0803h1.4472c-.0307.1629-.0934.3181-.1843.4568-.0909.1386-.2083.2579-.3455.351 0 0 0-.006-.001-.0062-.1771.1163-.3767.1942-.5858.2286-.2096.0384-.4245.0375-.6338-.0027-.2125-.044-.4137-.1312-.5911-.2562-.2619-.1857-.4638-.4437-.5812-.7425-.0089-.0233-.0172-.0467-.0256-.0705v-.0026l.0022-.0017c-.1138-.3342-.1141-.6966-.0008-1.031.0798-.2345.2111-.4482.3843-.6254.4064-.4203 1.0136-.5784 1.5733-.4097.2147.0659.4108.1813.5725.337l.4883-.4882c.0861-.087.1756-.1713.2584-.2612-.2475-.2309-.5381-.4109-.8552-.5296-.577-.2093-1.2082-.2148-1.7888-.0157-.0203.0069-.0404.0141-.0603.0215-.6264.2355-1.1417.6973-1.4441 1.2942-.1068.2113-.1846.4361-.2312.6682-.2766 1.3743.562 2.7271 1.9159 3.0908.4426.1185.9132.1156 1.3592.0143.4053-.0915.78-.2863 1.0878-.5653.3212-.2955.5513-.6891.6719-1.1073.1009-.3543.1374-.7238.1079-1.0911z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMyBusinessRoundLogo);
export default __webpack_public_path__ + "static/media/google-my-business-round-logo.9f5e707ba879afc7b170c67dbefe2ff7.svg";
export { ForwardRef as ReactComponent };